import React from 'react'

function CoiLisSauPar() {
  return (
    <>
       <head style={{all:'initial'}}>
                <title>شركات تأسيس أعمال في جدة</title>
                <meta name="description" content="شركات تأسيس أعمال في جدة"/>
                <meta name="keywords" content="شركات تأسيس أعمال في جدة" />
            </head>
      <div style={{ padding: '50px', fontSize: '10px' }}>
          <h1>
              تقدم الخدمة للمنشآت الاجنبية التي ترغب في ممارسة نشاط
              <br />
              تجارة الجملة والتجزئة في المملكة مع شريك سعودي
              </h1>
      </div>
    </>
  )
}

export default CoiLisSauPar